import {
  GetLocationEmailsWithLatestStatusRequest,
  GetLocationEmailsWithLatestStatusResponse,
  GetLocationPersonalizationRequest,
  GetLocationPersonalizationResponse,
  UpsertLocationPersonalizationRequest,
} from '@weave/schema-gen-ts/dist/schemas/email/records/v1/records_service.pb';
import { AxiosError } from 'axios';
import { CustomAxios, getResponseData } from 'redux/axios';

export const getLocationPersonalization = async (
  req: GetLocationPersonalizationRequest
) => {
  try {
    const response = await CustomAxios.get<GetLocationPersonalizationResponse>(
      `/email/records/v1/location_preference/${req.locationId}`
    );
    return getResponseData<GetLocationPersonalizationResponse>(response);
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response && axiosError.response.data) {
      throw axiosError.response.data;
    }
    throw {
      code: -1,
      message: axiosError.message || 'Unknown error',
      details: [],
    };
  }
};

export const upsertLocationPersonalization = async (
  req: UpsertLocationPersonalizationRequest
): Promise<void> => {
  await CustomAxios.put(`/email/records/v1/location_preference/${req.locationId}`, req);
};

export const getLocationEmailsWithLatestStatus = async (
  req: GetLocationEmailsWithLatestStatusRequest
) => {
  const response = await CustomAxios.post<GetLocationEmailsWithLatestStatusRequest>(
    `/email/records/v1/location/${req.locationId}/emails`,
    req
  );
  return getResponseData<GetLocationEmailsWithLatestStatusResponse>(response);
};
